module.exports = __webpack_public_path__ + "static/concord-logo-bc5c7174b436832d83effef760e2025d.png";